export enum PORTALS {
  MODAL = 'modal-portal',
  APP_BANNER = 'app-banner-portal',
}
